export const colours = {
  black: '#363640',
  shadow: '#363640',
  white: '#FFFFFF',
  primary: '#CC5500',
  lime: '#C9DE4B',
  ink: '#3C320F',
  cream: '#FFFFF6',
  footer: '#221F1B',
  grey: {
    lightest: '#F4F4F4',
    lighter: '#EEEEEE',
    light: '#CCCCCC',
  },
};

export const fonts = {
  brand: 'Poppins, sans-serif',
  body: '"IBM Plex Sans", sans-serif',
};

export const minBreakpointWidths = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

export const spacing = {
  pagePadding: 20,
  navbarHeight: 72,
};

export const breakpoints = {
  xxs: {
    min: 0,
    max: minBreakpointWidths.xs - 1,
  },
  xs: {
    min: minBreakpointWidths.xs,
    max: minBreakpointWidths.sm - 1,
  },
  sm: {
    min: minBreakpointWidths.sm,
    max: minBreakpointWidths.md - 1,
  },
  md: {
    min: minBreakpointWidths.md,
    max: minBreakpointWidths.lg - 1,
  },
  lg: {
    min: minBreakpointWidths.lg,
    max: minBreakpointWidths.xl - 1,
  },
  xl: {
    min: minBreakpointWidths.xl,
    max: Infinity,
  },
};

export const shadows = {
  header: '0 8px 50px 0 rgba(0, 0, 0, 0.12)',
  popup: '0 4px 8px 0 rgba(0, 0, 0, 0.10)',
};
